import Select from "./Select"
import Search from "./Search"
export default { Select, Search }
